import { render, staticRenderFns } from "./TasksAdd.vue?vue&type=template&id=7cbab8e0&scoped=true&"
import script from "./TasksAdd.vue?vue&type=script&lang=js&"
export * from "./TasksAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbab8e0",
  null
  
)

export default component.exports